import styled from "styled-components";
import {MAIN_COLOR} from "../../../components/globalThemes";

export const ContactSection = styled.div`
    height: 450px;
    display: flex;
    align-items: center;
    flex-direction: row;
    position: relative;
    overflow: hidden;
    
    @media (max-width: 1140px) {
        flex-direction: column;
        height: ${({portraitHeight}) => portraitHeight ?? '450px'};
    }
`;

export const ContactEmail = styled.div`
    display: inline-block;
    font-size: 21px;
    font-family: BlenderProBold, serif;
    font-weight: bold;
    color: white;
    display: flex;
    
    &:hover {
        border-bottom: 2px solid white;
    }
`;

export const StyledFont = styled.span`
    color: ${({color}) => color ?? MAIN_COLOR};        
`;

export const QuoteFromTeam = styled.p`
    user-select: none;
    font-size: 15px;
    font-family: Caveat, serif;
    color: white;
    white-space: pre-wrap;
    line-height: 1.5;
    margin-top: -15px;
`;

export const ContactInfo = styled.div`
    flex: 2;
    background-color: #1c1f1c99;
    width: 100%;
    height: 100%;
    clip-path: polygon(25% 0%, 100% 0, 100% 81%, 25% 81%, 0 65%, 0 19%);
    
    @media (max-width: 1140px) {
        clip-path: none;
        max-height: 250px;
    }
`;

export const ContactContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 50px;
    
    @media (max-width: 1140px) {
        order: 1;
        margin: 0;
    }
`;

export const ContactContent = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-decoration: none;
`;

export const StyledInfo = styled.div`
    flex: 1;
    height: 250px;  
    background-color: #1c1f1c99;
    clip-path: polygon(0 0, 75% 0%, 100% 50%, 75% 100%, 0 99%, 0% 50%);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    
    @media (max-width: 1140px) {
        clip-path: none;
        width: 100%;
        order: 3;
    }
`;

export const StyledInfoWrapper = styled.div`
    margin-left: -30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 20px;
    
    @media (max-width: 1140px) {
        margin: 0;
        flex-direction: row;
    }
`;
